import { useRouter } from "next/router";
import React, {useState, useEffect} from "react";
import { useWineContext } from "../../../context/wineContext";
import {useAuth} from "../../../context/authContext"
import BaseWineResult from "../../global/BaseWines/BaseWineResult";
import ProducerResult from "../../global/BaseWines/ProducerResult";
import Pagination from "../../global/Pagination/Pagination";
import WineVintage from "../../global/Wines/WineVintage";
import { v4 as uuidv4 } from 'uuid';
import Loading from "../../global/Loading";

const BaseWineResults = (props: {
  term: string,
  type: string,
  onTypeChange: Function,
  onPageChange?: Function
  year?: string

}) => {
  const router = useRouter();
  const {
    state: { loading, producers, producersTotal, baseWines, baseWinesTotal, wineVintages, wineVintagesTotal, wines, winesTotal },
    dispatch: winesDispatch,
  } = useWineContext();

  
  const { state: { user }} = useAuth()
  const [openAll, setOpenAll] = useState(false)

  useEffect(()=>{
    if(props.type === "reviews" && user){
        setOpenAll(true)
    } else {
      setOpenAll(false)
    }
  },[props.type, user])

  const handlePageChange = (e) => {
    if(props.onPageChange) {
      props.onPageChange({ page: e.page, per_page: e.perPage });
    } else {
      router.push({
        pathname: '/wines',
        query: {
          ...router.query,
          term: props.term,
          page: e.page,
          per_page: e.perPage
        }
      }, undefined, { shallow: true })
    }
  }

  return (
    loading ? <Loading isLoading={loading}/> : <div>
      <div className="space-y-2">
        <div className="flex flex-row align-end">
          <div
            className={`transition text-lg md:text-xl text-center px-2 py-1 mb-4 mr-1.5 md:mr-8 border-b opacity-70 ${ props.type === "reviews" && "border-red opacity-100" } cursor-pointer hover:border-red hover:opacity-100`}
            onClick={() => { props.onTypeChange("reviews") }}
            onKeyDown={(e) => e.key === "Enter" && props.onTypeChange("reviews")}
            role="button"
            tabIndex={0}
          >
            Reviews
          </div>
          <div
            className={`transition text-lg md:text-xl text-center px-2 py-1 mb-4 mr-1.5 md:mr-8 border-b opacity-70 ${ props.type === "wineVintage" && "border-red opacity-100" } cursor-pointer hover:border-red hover:opacity-100`}
            onClick={() => { props.onTypeChange("wineVintage") }}
            onKeyDown={(e) => e.key === "Enter" && props.onTypeChange("wineVintage")}
            role="button"
            tabIndex={0}
          >
            Vintages
          </div>
          <div
            className={`transition text-lg md:text-xl text-center px-2 py-1 mb-4 mr-1.5 md:mr-8 border-b opacity-70 ${ props.type === "baseWine" && "border-red opacity-100" } cursor-pointer hover:border-red hover:opacity-100`}
            onClick={() => { props.onTypeChange("baseWine") }}
            onKeyDown={(e) => e.key === "Enter" && props.onTypeChange("baseWine")}
            role="button"
            tabIndex={0}
          >
            Wines
          </div>
          <div
            className={`transition text-lg md:text-xl text-center px-2 py-1 mb-4 mr-1.5 md:mr-8 border-b opacity-70 ${ props.type === "producer" && "border-red opacity-100" } cursor-pointer hover:border-red hover:opacity-100`}
            onClick={() => { props.onTypeChange("producer") }}
            onKeyDown={(e) => e.key === "Enter" && props.onTypeChange("producer")}
            role="button"
            tabIndex={0}
          >
            Producers
          </div>
        </div>

        {
          props.type === "baseWine" && baseWines && baseWines.length > 0 ?
          <div>
            <Loading isLoading={loading && baseWines?.length < 0}/>
            { baseWines &&
              baseWines.map(bw => {
                return (
                  <BaseWineResult
                    key={bw.slug}
                    baseWine={bw}
                    year={props.year}
                  />
                )
              })
            }

            {
              baseWines &&
              baseWinesTotal > 25 &&
              <Pagination
                records={baseWinesTotal}
                onPageChange={(e) => handlePageChange(e)}
              />
            }
          </div> : props.type ==="baseWine" && baseWines?.length === 0 && <div className="text-center pt-32 text-lg">No wines found, please try again.</div>
        }

        {
          props.type === "wineVintage" && wineVintages && wineVintages.length > 0 ?
          <div>
            <Loading isLoading={loading && wineVintages?.length < 0}/>
          <div className="flex items-center justify-end justify-self-end pb-4 w-full">
            <div
              className="transition w-4  cursor-pointer hover:text-red"
              onClick={() => {
                setOpenAll(!openAll);
              }}
              onKeyDown={(e) => e.key === "Enter" && setOpenAll(!openAll)}
              role="button"
              tabIndex={0}
              aria-label={openAll ? "Close All" : "Open All"}
            >
              {
                openAll ?
                <svg width="16px" height="16px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                    <g id="Page-1" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                        <g id="v" transform="translate(-366.000000, -283.000000)" strokeWidth="2">
                            <g id="Group-Copy" transform="translate(367.000000, 284.000000)">
                                <path d="M12.5,1.5 L12.5,5.5 M12.5,5.5 L16.5,5.5 M12.5,5.5 L17.5,0.5 M5.5,16.5 L5.5,12.5 M5.5,12.5 L1.5,12.5 M5.5,12.5 L0.5,17.5" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </svg>
                :
                <svg width="16px" height="16px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                    <g id="Page-1" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                        <g id="v" transform="translate(-327.000000, -284.000000)" strokeWidth="2">
                            <g id="Group" transform="translate(327.000000, 284.000000)">
                                <path d="M17,5 L17,1 M17,1 L13,1 M17,1 L12,6 M1,13 L1,17 M1,17 L5,17 M1,17 L6,12" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </svg>
              }
              </div>
            </div>
            { wineVintages &&
              wineVintages.map((wineVintage, _idx) => {
                return (
                  <WineVintage
                    wine={[...wineVintage.wines].sort((l,r) => {
                      return l.review_date < r.review_date ? 0 : -1;
                    }).filter(wine => wine.vintage === wineVintage.vintage)[0]}
                    slug={wineVintage.base_wine?.slug}
                    producerName={wineVintage.base_wine?.producer?.producer_name}
                    open={openAll}
                    key={uuidv4()}
                  />
                )
              })
            }

            {

              wineVintagesTotal > 25 &&
              <Pagination
                records={wineVintagesTotal}
                onPageChange={(e) => handlePageChange(e)}
              />
            }
          </div> : props.type === "wineVintage" && wineVintages?.length === 0 && <div className="text-center pt-32 text-lg">No vintage found. Please try again</div>
        }

        {
          props.type === "producer" && producers && producers.length > 0 ?
          <div>
            { producers &&
              producers.map(prod => {
                return (
                  <ProducerResult
                    key={prod.slug}
                    producer={prod}
                  />
                )
              })
            }

            {
              producers &&
              producersTotal > 25 &&
              <Pagination
                records={producersTotal}
                onPageChange={(e) => handlePageChange(e)}
              />
            }
          </div> : props.type === "producer" && producers?.length === 0 && <div className="text-center pt-32 text-lg">No producers found, please try again.</div>
        }

        {
          props.type === "reviews" && wines?.length > 0 ?
          <div>
            <Loading isLoading={loading && wines?.length < 0}/>
            <div className="flex items-center justify-end justify-self-end pb-4 w-full">
              <div
                className="transition w-4 cursor-pointer hover:text-red"
                onClick={() => {
                  setOpenAll(!openAll);
                }}
                onKeyDown={(e) => e.key === "Enter" && setOpenAll(!openAll)}
                role="button"
                tabIndex={0}
                aria-label={openAll ? "Close All" : "Open All"}
              >
                {
                  openAll ?
                  <svg width="16px" height="16px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                      <g id="Page-1" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                          <g id="v" transform="translate(-366.000000, -283.000000)" strokeWidth="2">
                              <g id="Group-Copy" transform="translate(367.000000, 284.000000)">
                                  <path d="M12.5,1.5 L12.5,5.5 M12.5,5.5 L16.5,5.5 M12.5,5.5 L17.5,0.5 M5.5,16.5 L5.5,12.5 M5.5,12.5 L1.5,12.5 M5.5,12.5 L0.5,17.5" id="Shape"></path>
                              </g>
                          </g>
                      </g>
                  </svg>
                  :
                  <svg width="16px" height="16px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                      <g id="Page-1" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                          <g id="v" transform="translate(-327.000000, -284.000000)" strokeWidth="2">
                              <g id="Group" transform="translate(327.000000, 284.000000)">
                                  <path d="M17,5 L17,1 M17,1 L13,1 M17,1 L12,6 M1,13 L1,17 M1,17 L5,17 M1,17 L6,12" id="Shape"></path>
                              </g>
                          </g>
                      </g>
                  </svg>
                }
                </div>
              </div>
              { wines &&
                wines.map((wine, idx) => {
                  return (
                    <WineVintage
                      wine={wine}
                      slug={wine.slug}
                      producerName={wine.producer.producer_name}
                      open={openAll}
                      useBaseWineId={true}
                      key={uuidv4()}
                  />
                  )
                })
              }

              {
                wines &&
                winesTotal > 25 &&
                <Pagination
                  records={winesTotal}
                  onPageChange={(e) => handlePageChange(e)}
                />
              }
            </div> : props.type === "reviews" && wines?.length === 0 && <div className="text-center pt-32 text-lg">No reviews found, please try again.</div>
        }
        </div>
    </div>
  )
}

export default BaseWineResults;
